// @ts-ignore
import ProfileImg from "@assets/images/profilepic.png";
// @ts-ignore
import AgencyImg from "@assets/images/agency.jpg";
// @ts-ignore
import GoogleImg from "@assets/images/google.jpg";
import CalenderIcon from "@assets/svg/CalenderIcon";
import AssessmentIcon from "@assets/svg/AssessmentIcon";
import EyeIcon from "@assets/svg/EyeIcon";
import EditIcon from "@assets/svg/EditIcon";
import ProfileIcon from "@assets/svg/ProfileIcon";
import JobMatchesIcon from "@assets/svg/JobMatchesIcon";
import { Briefcase, LogOut } from "lucide-react";
import dayjs from "dayjs";
import PlusCircleIcon from "@assets/svg/PlusCircleIcon";

type TrackerType =
  | "placement"
  | "offerAccepted"
  | "offer"
  | "invitation"
  | "interview"
  | "poll"
  | "shortlist"
  | "view"
  | "submit"
  | "posted"
  | "requirementSubmitted"
  | "agentAdd"
  | "edit"
  | "register";

function getIcon(type: TrackerType) {
  switch (type) {
    case "placement":
      return <Briefcase className={"w-5 h-5"} stroke="gray" />;
    case "offer":
      return <JobMatchesIcon className={"w-5 h-5"} fill={"gray"} />;
    case "offerAccepted":
      return <JobMatchesIcon className={"w-5 h-5"} fill={"gray"} />;
    case "invitation":
      return <CalenderIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "interview":
      return <CalenderIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "poll":
      return <CalenderIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "shortlist":
      return <AssessmentIcon className={"w-5 h-5"} fill={"gray"} />;
    case "submit":
      return <LogOut height={22} color="gray" />;
    // return <CommissionIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "view":
      return <EyeIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "agentAdd":
      return <PlusCircleIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "edit":
      return <EditIcon className={"w-5 h-5"} fill={"gray"} />;
    case "register":
      return <ProfileIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    default:
      return <AssessmentIcon className={"w-5 h-5"} fill={"gray"} />;
  }
}
function getTitle(type: TrackerType) {
  switch (type) {
    case "placement":
      return "Placement successful";
    case "offerAccepted":
      return "Offer Accepted";
    case "offer":
      return "Offer";
    case "invitation":
      return "Interview time accepted";
    case "interview":
      return "Interview";
    case "poll":
      return "Availability poll";
    case "shortlist":
      return "Candidate Shortlisted";
    case "view":
      return "Application Viewed";
    case "submit":
      return "Candidate Submitted";
    case "posted":
      return "Requirement Posted";
    case "requirementSubmitted":
      return "Requirement Submitted";
    case "agentAdd":
      return "Requirement Agent Added";
    case "edit":
      return "Profile Edit";
    case "register":
      return "Registration";
    default:
      return "Default";
  }
}

function getDescImage(type: TrackerType) {
  switch (type) {
    case "offer":
      return <img src={ProfileImg} className="w-7 h-7 rounded-full" />;
    case "invitation":
      return <img src={ProfileImg} className="w-7 h-7 rounded-full" />;
    case "interview":
      return <img src={ProfileImg} className="w-7 h-7 rounded-full" />;
    case "poll":
      return <img src={ProfileImg} className="w-7 h-7 rounded-full" />;
    case "shortlist":
      return <img src={GoogleImg} className="w-7 h-7 rounded-full" />;
    case "submit":
      return <img src={AgencyImg} className="w-7 h-7 rounded-full" />;
    case "posted":
      return <img src={AgencyImg} className="w-7 h-7 rounded-full" />;
    case "view":
      return <img src={ProfileImg} className="w-7 h-7 rounded-full" />;
    default:
      return <img src={ProfileImg} className="w-7 h-7 rounded-full" />;
  }
}

function getDescription(type: TrackerType) {
  switch (type) {
    case "placement":
      return (
        <span className="flex flex-wrap items-center gap-1 text-xs font-medium text-charcoal">
          <span className="font-bold text-gray-600">Jo Bloggs</span>
          <span>have been successfully placed at</span>
          <img src={GoogleImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Google Inc</span>
          for a requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "offer":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You</span>
          submitted an offer to
          <img src={ProfileImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Jo Bloggs</span>
          for a requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "offerAccepted":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">Jo Bloggs </span>
          has accepted an offer from
          <img src={GoogleImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Google Inc Europe</span>
          for a requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "invitation":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">Jo Bloggs</span>
          accepted an interview time 14:00 Thursday 8th of November for
          requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "interview":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You</span>
          sent an interview invitation to
          <span className="font-bold text-gray-600">Jo Bloggs</span>
          for requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "poll":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You</span>
          sent an availability poll to
          <img src={ProfileImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Jo Bloggs</span>
        </span>
      );
    case "shortlist":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You</span>
          have shortlisted candidate
          <img src={ProfileImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Jo Bloggs</span>
          for your requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer
          </span>
        </span>
      );
    case "view":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You</span>
          viewed
          <img src={ProfileImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Jo Bloggs's</span>
          application for requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.{" "}
          </span>
        </span>
      );
    case "submit":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          has submitted candidate
          <img src={ProfileImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Jo Bloggs's</span>
          for your requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.{" "}
          </span>
        </span>
      );
    case "posted":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          has posted a job for your requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.{" "}
          </span>
        </span>
      );
    case "requirementSubmitted":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You</span>
          submitted a new requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer
          </span>
          to
          <img src={AgencyImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">ABC Recruitment </span>
        </span>
      );
    case "agentAdd":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You</span>
          added
          <img src={AgencyImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          to your Recruitment Agency Network.
        </span>
      );
    case "edit":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You </span>
          successfully updated
          <img src={AgencyImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">ABC Recruitment</span>
          details.
        </span>
      );
    case "register":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You </span>
          successfully registered an admin account on behalf of{" "}
          <img src={AgencyImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">ABC Recruitment.</span>
        </span>
      );
    default:
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          sent you an offer from{" "}
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          regarding
          <span className="font-bold text-gray-600">ABC Recruitment.</span>
        </span>
      );
  }
}

type CardProps = {
  type: TrackerType;
};

const Card = ({ type }: CardProps) => {
  return (
    <div className="flex gap-3">
      <div className="flex items-center justify-center w-6 h-6 rounded-full">
        {getIcon(type)}
      </div>
      <div className="flex flex-col gap-1 w-full pt-1">
        <span className="font-semibold text-xs gap-5 flex text-charcoal">
          {getTitle(type)}
          <span className="font-medium text-light-black">
            {dayjs().format("HH:mm DD/MM/YYYY")}
          </span>
        </span>
        <div className="flex items-center text-xs text-charcoal bg-[#fafafa] w-full rounded-md p-3 gap-3">
          {getDescImage(type)}
          {getDescription(type)}
        </div>
      </div>
    </div>
  );
};

const HiringTrackerPageStatic = () => {
  return (
    <div className="flex flex-col flex-1 min-h-0 rounded-md bg-white p-5">
      <span className="font-bold text-charcoal mx-auto">Activity Tracker</span>

      {/* Tracker List */}
      <div className="flex flex-col min-h-0 my-10 w-[70%] mx-auto gap-6 overflow-y-scroll no-scrollbar">
        <Card type="placement" />
        <Card type="offerAccepted" />
        <Card type="offer" />
        <Card type="invitation" />
        <Card type="interview" />
        <Card type="poll" />
        <Card type="shortlist" />
        <Card type="view" />
        <Card type="submit" />
        <Card type="posted" />
        <Card type="requirementSubmitted" />
        <Card type="agentAdd" />
        <Card type="edit" />
        <Card type="register" />
      </div>
    </div>
  );
};

export default HiringTrackerPageStatic;
